import { render, staticRenderFns } from "./featureDrops.vue?vue&type=template&id=6730623e&scoped=true"
import script from "./featureDrops.vue?vue&type=script&lang=js"
export * from "./featureDrops.vue?vue&type=script&lang=js"
import style0 from "./featureDrops.vue?vue&type=style&index=0&id=6730623e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6730623e",
  null
  
)

export default component.exports